import { MULTI_RUN_LIMIT } from "@/runs/multi-run"

export interface UploadedReportSelection {
  runIds: string[]
  simulationOutputIds: string[]
}

export function buildUploadedReportSearchParams(
  selection: UploadedReportSelection,
) {
  return new URLSearchParams({
    is_monitoring: "true",
    run_ids: selection.runIds.slice(0, MULTI_RUN_LIMIT).join(","),
    simulation_output_ids: selection.simulationOutputIds
      .slice(0, MULTI_RUN_LIMIT)
      .join(","),
  })
}

export function isUploadedReportSelectionOverLimit(
  selection: UploadedReportSelection,
) {
  return (
    selection.runIds.length > MULTI_RUN_LIMIT ||
    selection.simulationOutputIds.length > MULTI_RUN_LIMIT
  )
}
